import { ADMIN_PROVISION_ACTION_TYPES } from '../../constants/actionTypes/adminProvisionActionTypes';

interface IAction {
    type: string;
    payload?: any;
}

export const INITITAL_STATE = {
    privileges: {
        provisioningRoleList: [],
        provisioningRuleList: [],
        managedRoleList: [],
    },
    filteredProvisioningRules: [],
    hasError: false,
};

export default (state = INITITAL_STATE, action: IAction) => {
    switch (action?.type) {
        case ADMIN_PROVISION_ACTION_TYPES.SET_ADMIN_PRIVILEGES: {
            return {
                ...state,
                privileges: {
                    provisioningRoleList: action.payload.provisioning_roles,
                    provisioningRuleList: action.payload.provisioning_rules,
                    managedRoleList: action.payload.managed_roles,
                },
                filteredProvisioningRules: action.payload.provisioning_rules,
            };
        }
        case ADMIN_PROVISION_ACTION_TYPES.UPDATE_FILTERED_PROVISIONING_RULES: {
            return {
                ...state,
                filteredProvisioningRules: action.payload,
            };
        }
        case ADMIN_PROVISION_ACTION_TYPES.SET_API_ERROR_MSG: {
            return {
                ...state,
                hasError: action.payload,
            };
        }
        default:
            return state;
    }
};
